import { useEffect, useState } from "react";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminDthReport() {
  const [dthRecharges, setDthRecharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch DTH Recharge data
  const fetchDthRecharges = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllDthRecharges`);
      console.log("API Response:", response.data);

      if (response.data.data) {
        setDthRecharges(response.data.data);
      } else {
        setDthRecharges([]);
      }
    } catch (error) {
      console.error("Error fetching DTH recharge data:", error);
      setError("Failed to load DTH recharge report.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDthRecharges();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <AdminBookingNavbar />

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">DTH Recharge Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading DTH recharge report...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Request ID</th>
                              <th>Subscriber ID</th>
                              <th>Operator</th>
                              <th>Amount</th>
                              <th>Status</th>
                              <th>Transaction ID</th>
                              <th>Transaction Description</th>
                              <th>Date</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dthRecharges.length > 0 ? (
                              dthRecharges.map((recharge, index) => (
                                <tr key={recharge.request_id}>
                                  <td>{index + 1}</td>
                                  <td>{recharge.request_id}</td>
                                  <td>{recharge.subscriber_id}</td>
                                  <td>{recharge.operator}</td>
                                  <td>&#8377; {recharge.amount}</td>
                                  <td>
                                    <span className={`badge 
                                      ${recharge.txn_status === "SUCCESS" ? "bg-success" : "bg-danger"}
                                    `}>
                                      {recharge.txn_status}
                                    </span>
                                  </td>
                                  <td>{recharge.txnid}</td>
                                  <td>{recharge.txn_desc}</td>
                                  <td>{new Date(recharge.created_at).toLocaleDateString()}</td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  No DTH recharge records found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminDthReport;
